export enum Environment {
  PRODUCTION,
  STAGING,
  PREVIEW,
  LOCAL,
}
